import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { formatDateTime } from '../../../../utils/formatter/dateTimeFormatter';
import { useParams, useNavigate } from 'react-router-dom';

const ValidationRunsTable = ({ validationRuns = [], loading }) => {
  const { connectionId, employerId } = useParams();
  const navigate = useNavigate();

  if (loading) {
    return (
      <Typography>
        <FormattedMessage id="validationRuns.table.loading" />
      </Typography>
    );
  }

  if (!validationRuns || validationRuns.length === 0) {
    return (
      <Typography>
        <FormattedMessage id="validationRuns.noData" />
      </Typography>
    );
  }

  const handleViewDetails = validationRunId => {
    navigate(`/employers/${employerId}/connections/${connectionId}/validation-runs/${validationRunId}`);
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <FormattedMessage id="validationRuns.table.createdAt" />
            </TableCell>
            <TableCell>
              <FormattedMessage id="validationRuns.table.totalMutations" />
            </TableCell>
            <TableCell>
              <FormattedMessage id="validationRuns.table.totalEvents" />
            </TableCell>
            <TableCell>
              <FormattedMessage id="validationRuns.table.actions" />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {validationRuns.map(run => (
            <TableRow key={run.validationRunId}>
              <TableCell>{formatDateTime(run.createdAt)}</TableCell>
              <TableCell>{run.totalMutations}</TableCell>
              <TableCell>{run.totalEvents}</TableCell>
              <TableCell>
                <Button variant="outlined" size="small" onClick={() => handleViewDetails(run.validationRunId)}>
                  <FormattedMessage id="button.details" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ValidationRunsTable;
